import { render, staticRenderFns } from "./SecondsInput.vue?vue&type=template&id=633f4420&scoped=true"
import script from "./SecondsInput.vue?vue&type=script&lang=js"
export * from "./SecondsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f4420",
  null
  
)

export default component.exports